import React from 'react';
import { View } from 'react-native';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput, useFormSubmit } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Notice } from 'app/src/elements/Notice';
import { Title } from 'app/src/styles';
import { useNavigate } from 'app/src/utils/routing';

import { CREATE_LIBRARY } from './queries';

export const FIELDS = {
  name: {
    label: 'Name',
    rules: { required: true },
  },
  access: {
    label: 'Access Level',
    rules: { required: true },
    select: [
      { value: '', label: 'Select' },
      { value: 'private', label: 'Private' },
      { value: 'shareable', label: 'Shareable' },
      { value: 'public', label: 'Public' },
    ],
  },
  description: {
    label: 'Description',
  },
};

const NewLibrary = () => {
  const navigate = useNavigate();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { submit: createLibrary, formStatus, errorMessage } =
    useFormSubmit(CREATE_LIBRARY, {
      onCompleted: data => {
        navigate(`/libraries/${data.createLibrary.library.id}`)
      }
    });

  const onSubmit = input => {
    createLibrary({ variables: { input: prepareInput(input, FIELDS) } });
  };

  const fields = { ...FIELDS };

  return (
    <View>
      <Title>Add Library</Title>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {errorMessage && <Notice type="error">{errorMessage}</Notice>}

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button
          label="Save to add things and event types"
          onPress={handleSubmit(onSubmit)}
          wide
        />
      )}
    </View>
  );
};

export default NewLibrary;
